import { render, staticRenderFns } from "./ApprovalList.vue?vue&type=template&id=2895b9e4&"
import script from "./ApprovalList.vue?vue&type=script&lang=js&"
export * from "./ApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalList.vue?vue&type=style&index=0&id=2895b9e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports